/**
 * View Transitions API helper.
 *
 * Wraps a navigation/state callback in `document.startViewTransition` when
 * the browser supports it (Chromium, Safari TP, etc.), so React state +
 * route changes inside the callback animate as a cross-fade between the
 * old and new frames. Falls back to running the callback immediately on
 * unsupported browsers (Firefox today) — the navigation still happens,
 * just without the visual transition.
 *
 * Used for the landing → /fit and /fit → landing transitions where the
 * matching cloud-sky palette makes a cross-fade feel like one continuous
 * sky scene rather than a hard route swap.
 */

type ViewTransitionDocument = Document & {
  startViewTransition?: (callback: () => void | Promise<void>) => unknown;
};

export function startViewTransition(callback: () => void | Promise<void>): void {
  if (typeof document === "undefined") {
    void callback();
    return;
  }
  const doc = document as ViewTransitionDocument;
  if (typeof doc.startViewTransition === "function") {
    doc.startViewTransition(callback);
  } else {
    void callback();
  }
}
